(function () {
var BYS = window.BYS = window.BYS || {};
BYS.money = function (cents) { return '$' + (cents / 100).toFixed(2); };
BYS.esc = function (s) {
return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
};
function Picker(sideEl, ctx) {
this.ctx = ctx;
this.side = sideEl.getAttribute('data-bys-side') || '';
this.styleSel = sideEl.querySelector('[data-bys-style]');
this.optionsEl = sideEl.querySelector('[data-bys-options]');
this.media = sideEl.querySelector('[data-bys-media]');
this.soldout = sideEl.querySelector('[data-bys-soldout]');
this.lowEl = sideEl.querySelector('[data-bys-low]');
this.best = sideEl.getAttribute('data-bys-best') || '';
this.lowstock = {};
this.product = null; this.variant = null; this.selected = [];
this.placeholder = this.media.innerHTML;
var self = this;
this.styleSel.addEventListener('change', function () { self.onStyle(); });
}
Picker.prototype.clear = function () {
this.product = null; this.variant = null; this.selected = [];
this.frames = null; this.frameIdx = 0;
this.optionsEl.innerHTML = '';
this.soldout.hidden = true;
if (this.lowEl) this.lowEl.hidden = true;
this.media.innerHTML = this.placeholder;
};
Picker.prototype.preselect = function () {
if (this.styleSel.value) return;
for (var i = 0; i < this.styleSel.options.length; i++) {
if (this.styleSel.options[i].value) {
this.styleSel.value = this.styleSel.options[i].value;
this.onStyle();
return;
}
}
};
Picker.prototype.onStyle = function (keepSel) {
var handle = this.styleSel.value, self = this;
var prev = this.product ? String(this.product.handle) : '';
if (!handle) { this.clear(); this.ctx.onChange(); return; }
var attempt = function (retriesLeft) {
self.ctx.fetchProduct(handle).then(function (p) {
if (self.styleSel.value !== handle) return;
self.product = p;
if (!(keepSel === true && self.selected.length)) {
var first = null;
for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { first = p.variants[i]; break; } }
if (!first) first = p.variants[0];
self.selected = ((first && first.options) || []).slice();
}
self.resolve(-1);
}, function (err) {
if (self.styleSel.value !== handle) return;
if (retriesLeft > 0) { attempt(retriesLeft - 1); return; }
if (prev) {
self.styleSel.value = prev;
} else {
self.clear();
}
if (window.console && console.error) console.error('BYS style load failed:', handle, err);
self.ctx.onChange();
if (BYS._api && BYS._api.setError) {
BYS._api.setError('We could not load that style just now. Please try it again.');
}
});
};
attempt(1);
};
Picker.prototype.buildFrames = function (variant) {
var p = this.product;
var frames = [];
var main = (variant && variant.featured_image && variant.featured_image.src) || p.featured_image || null;
if (main) frames.push(main);
var claimed = {};
(p.variants || []).forEach(function (v) {
if (v.featured_image && v.featured_image.src) claimed[String(v.featured_image.src).split('?')[0]] = true;
});
var title = String(p.title || '').trim();
(p.media || []).forEach(function (m) {
if (!m || !m.src || (m.media_type && m.media_type !== 'image')) return;
if (claimed[String(m.src).split('?')[0]]) return;
if (!title) return;
var alt = String(m.alt || '').trim();
if (alt.toLowerCase().indexOf(title.toLowerCase()) !== 0) return;
if (alt.length !== title.length && /[A-Za-z0-9]/.test(alt.charAt(title.length))) return;
if (frames.indexOf(m.src) < 0) frames.push(m.src);
});
return frames;
};
Picker.prototype.renderMedia = function () {
var p = this.product, esc = BYS.esc, self = this;
var frames = this.frames || [];
if (!p) return;
if (!frames.length) { this.media.innerHTML = '<span>' + esc(p.title || '') + '</span>'; return; }
if (this.frameIdx == null || this.frameIdx >= frames.length || this.frameIdx < 0) this.frameIdx = 0;
var i = this.frameIdx;
var src = String(frames[i]).replace(/(\.[a-z]+)(\?|$)/i, '_1200x$1$2');
var html = '<img src="' + esc(src) + '" alt="' + esc(p.title || '') + '">';
if (frames.length > 1 && BYS._gallery === true) {
html += '<button type="button" class="bys__navbtn bys__navbtn--prev" data-bys-frame="-1" aria-label="Previous image">&#8249;</button>' +
'<button type="button" class="bys__navbtn bys__navbtn--next" data-bys-frame="1" aria-label="Next image">&#8250;</button>' +
'<div class="bys__dots">';
for (var k = 0; k < frames.length; k++) {
html += '<span class="bys__dot' + (k === i ? ' is-on' : '') + '"></span>';
}
html += '</div>';
}
var hadFocus = document.activeElement && this.media.contains(document.activeElement)
? document.activeElement.getAttribute('data-bys-frame') : null;
this.media.innerHTML = html;
var isNew = false;
for (var tg = 0; tg < (p.tags || []).length; tg++) {
if (String(p.tags[tg]).toLowerCase().indexOf('new 20') > -1) { isNew = true; break; }
}
if (isNew) {
this.media.insertAdjacentHTML('beforeend', '<span class="bys__badge">New</span>');
}
if (this.best && this.best === this.styleSel.value) {
this.media.insertAdjacentHTML('beforeend', '<span class="bys__badge">Best Seller</span>');
}
if (this.variant) {
this.media.insertAdjacentHTML('beforeend', '<span class="bys__pricetag">' + BYS.money(this.variant.price) + '</span>');
}
[].slice.call(this.media.querySelectorAll('[data-bys-frame]')).forEach(function (b) {
if (hadFocus !== null && b.getAttribute('data-bys-frame') === hadFocus) b.focus();
b.addEventListener('click', function (e) {
e.preventDefault();
var step = parseInt(b.getAttribute('data-bys-frame'), 10) || 1;
var n = self.frames.length;
self.frameIdx = ((self.frameIdx + step) % n + n) % n;
self.renderMedia();
});
});
};
Picker.prototype.imageFor = function (i, val) {
var p = this.product;
for (var k = 0; k < p.variants.length; k++) {
var v = p.variants[k];
if (v.options[i] === val && v.featured_image && v.featured_image.src) return v.featured_image.src;
}
return null;
};
Picker.prototype.valueAvailable = function (i, val) {
var p = this.product, sel = this.selected;
return p.variants.some(function (v) {
if (v.options[i] !== val) return false;
for (var j = 0; j < i; j++) { if (sel[j] != null && v.options[j] !== sel[j]) return false; }
return v.available;
});
};
Picker.prototype.paint = function () {
var p = this.product, sel = this.selected, self = this;
var names = (p.options || []).map(function (o) { return (o && o.name) ? o.name : o; });
var af = document.activeElement;
var focusVal = (af && this.optionsEl.contains(af)) ? af.getAttribute('data-value') : null;
this.optionsEl.innerHTML = '';
names.forEach(function (name, i) {
var values = [];
p.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
var wrap = document.createElement('div');
wrap.className = 'bys__field';
var lab = document.createElement('label');
var guide = (/size/i.test(name) && self.side === 'top')
? '<a class="bys__sizeguide" href="/pages/pajamas-sizing">Size guide</a>'
: '';
lab.innerHTML = '<span class="bys__optlbl">' + BYS.esc(name) +
' <b>' + BYS.esc(sel[i] || '') + '</b></span>' + guide;
wrap.appendChild(lab);
var isColour = /colou?r/i.test(name);
var box = document.createElement('div');
box.className = isColour ? 'bys__swatches' : 'bys__pills';
values.forEach(function (val) {
var ok = self.valueAvailable(i, val);
var btn = document.createElement('button');
btn.type = 'button';
btn.setAttribute('data-value', val);
btn.setAttribute('aria-pressed', String(sel[i] === val));
if (!ok) btn.disabled = true;
if (isColour) {
btn.className = 'bys__sw';
btn.title = val + (ok ? '' : ' (sold out)');
btn.setAttribute('aria-label', btn.title);
var hex = (self.swatchHex && self.swatchHex[val]) || '';
if (hex) {
btn.style.setProperty('--sw', hex);
} else {
var src = self.imageFor(i, val);
if (src) {
var im = document.createElement('img');
im.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2');
im.alt = val; im.loading = 'lazy';
btn.appendChild(im);
}
}
} else {
btn.className = 'bys__pill';
btn.textContent = val;
}
btn.addEventListener('click', function () {
if (btn.disabled) return;
self.selected[i] = val;
self.resolve(i);
});
box.appendChild(btn);
});
wrap.appendChild(box);
self.optionsEl.appendChild(wrap);
});
if (focusVal !== null) {
var fb = this.optionsEl.querySelector('[data-value="' + String(focusVal).replace(/"/g, '\\"') + '"]');
if (fb) fb.focus();
}
};
Picker.prototype.resolve = function (changedIdx) {
var p = this.product, sel = this.selected;
if (!p) { this.ctx.onChange(); return; }
var match = null;
for (var i = 0; i < p.variants.length; i++) {
var v = p.variants[i], ok = true;
for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
if (ok) { match = v; break; }
}
if (!match || !match.available) {
var alt = null;
for (var k = 0; k < p.variants.length; k++) {
var c = p.variants[k];
if (!c.available) continue;
var fits = true;
for (var j2 = 0; j2 <= changedIdx && j2 < sel.length; j2++) {
if (c.options[j2] !== sel[j2]) { fits = false; break; }
}
if (fits) { alt = c; break; }
}
if (alt) { this.selected = (alt.options || []).slice(); match = alt; }
}
this.paint();
if (match && match.available) {
this.variant = match;
this.soldout.hidden = true;
this.frames = this.buildFrames(match);
this.frameIdx = 0;
this.renderMedia();
if (this.lowEl) {
var q = this.lowstock[String(match.id)];
if (q) {
this.lowEl.textContent = 'Only ' + q + ' left in stock';
this.lowEl.hidden = false;
} else {
this.lowEl.hidden = true;
}
}
} else {
this.variant = null;
this.soldout.hidden = false;
this.frames = this.buildFrames(null);
this.frameIdx = 0;
this.renderMedia();
if (this.lowEl) this.lowEl.hidden = true;
}
BYS._lastSide = this.side;
this.ctx.onChange();
};
BYS.Picker = Picker;
BYS.confetti = function (host, count) {
if (!host) return;
var colors = ['#eca49e', '#f4c3b1', '#637ea1', '#2c3d54', '#f7f5ef'];
var box = document.createElement('div');
box.className = 'bys__confetti';
for (var i = 0; i < (count || 22); i++) {
var s = document.createElement('span');
s.style.left = (Math.random() * 100) + '%';
s.style.background = colors[i % colors.length];
s.style.animationDelay = (Math.random() * 0.25) + 's';
s.style.transform = 'rotate(' + Math.floor(Math.random() * 360) + 'deg)';
box.appendChild(s);
}
host.appendChild(box);
setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 1800);
};
BYS.trackAdd = function (t, b, topTitle, bottomTitle) {
try {
var value = (t.price + b.price) / 100;
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
event: 'add_to_cart',
ecommerce: {
currency: 'USD', value: value,
items: [
{ item_id: String(t.id), item_name: topTitle || '', price: t.price / 100, quantity: 1 },
{ item_id: String(b.id), item_name: bottomTitle || '', price: b.price / 100, quantity: 1 }
]
}
});
if (typeof window.fbq === 'function') {
window.fbq('track', 'AddToCart', {
value: value, currency: 'USD',
content_ids: [String(t.id), String(b.id)], content_type: 'product'
});
}
} catch (e) {}
};
})();
